import {Component, OnDestroy, Input, OnInit} from '@angular/core';
import {FilterBase} from "../../../../../models/filter-base";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {FilterbaseService} from "../../filter-base/services/filterbase.service";

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.css'],
    standalone: false
})
export class CheckboxComponent implements OnDestroy, OnInit {
  /** Service subscriptions end with the component (they used to leak). */
  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  @Input() hideTitle: boolean =false;
  @Input() filterBase!: FilterBase;
  constructor(private filterBaseService: FilterbaseService) { }

  ngOnInit(): void {
    this.selected = this.filterBaseService.getQuestion(this.filterBase.key) === true;
    this.filterBaseService.getRemoveEvent().pipe(takeUntil(this.destroy$)).subscribe(key => {
      if (key === this.filterBase.key) this.selected = false;
    });
  }

  selected = false;

  set selectDate(value: Date){
    this.filterBaseService.addQuestion(this.filterBase.key, value);
  }

  onSelectedChange(value: boolean): void {
    if (value) this.filterBaseService.addQuestion(this.filterBase.key, true);
    else this.filterBaseService.deleteQuestion(this.filterBase.key);
  }

}
